import { useEffect, type ReactElement, type ReactNode } from "react"
import Navbar from "src/components/Navbar"
import Sidebar from "src/components/Sidebar"
import { DashboardEvent } from "src/utils/SignalR/DashboardEvent"
import DashboardMain from "./Main/DashboardMain"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "src/app/store"
import { getDealerDetail } from "src/features/dashboard/hooks/dealerDetail"
import { getExceptionEvents } from "../hooks/exceptionEvents"

export interface DashboardHomeProps {
        children?: ReactNode
}

export default function DashboardHome(props: DashboardHomeProps): ReactElement {
        const dispatch = useDispatch<AppDispatch>();
        const { authUser } = useSelector((state: RootState) => state.auth);

        useEffect(() => {
                dispatch(getDealerDetail(authUser?.DealerId));
                dispatch(getExceptionEvents(authUser?.DealerId));
        }, [])

        return <>
                <div className="grid grid-cols-[10%_90%] h-screen w-full">
                        <div className="h-full">
                                <Sidebar sideBarSelected="Dashboard" />
                        </div>
                        <div className="grid grid-rows-[10%_90%] w-full h-[inherit] p-2">
                                <div className="w-full">
                                        <div></div>
                                        <Navbar headerType="dashboard" />
                                        <DashboardEvent />
                                        <div></div>
                                </div>
                                <div className="grid gap-2 grid-rows-1 w-full">
                                        <DashboardMain />
                                </div>
                        </div>
                </div>
        </>
}
